import { useEffect } from 'react';

import {
  useBiopharmaGroupsActions
} from './BiopharmaGroupsContext';

import {
  getBiopharmaGroups,
} from './restApi';

const BiopharmaGroupsLoader = () => {
  const { initializeState, onResponse, onError } = useBiopharmaGroupsActions();

  useEffect(() => {
    initializeState();
  }, []);

  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  useEffect(() => {
    getBiopharmaGroups({
      onResponse,
      onError,
      body: {
        authenticityToken,
        pageNumber: 1,
      },
    });
  }, []);

  return null;
};

export default BiopharmaGroupsLoader;
